import React from "react"
import { Tag, Image, Dropdown } from "antd"
import { EditOutlined, CopyOutlined, StopOutlined, DeleteOutlined } from "@ant-design/icons"
import styles from "./CrewMembersTable.module.css"

/**
 * Crew members table columns configuration
 */
export const crewMembersColumns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: (a, b) => a.name.localeCompare(b.name),
    render: (text, record) => (
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <Image src={record.image} width={40} height={40} style={{ objectFit: "cover", borderRadius: 6 }} preview={false} />
        <span>{text}</span>
      </div>
    )
  },
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    sorter: (a, b) => a.title.localeCompare(b.title)
  },
  {
    title: "Role",
    dataIndex: "role",
    key: "role",
    sorter: (a, b) => a.role.localeCompare(b.role)
  },
  {
    title: "Phone",
    dataIndex: "phone",
    key: "phone",
    sorter: (a, b) => a.phone.localeCompare(b.phone)
  },
  {
    title: "Assigned to",
    dataIndex: "assignedTo",
    key: "assignedTo",
    sorter: (a, b) => a.assignedTo.localeCompare(b.assignedTo)
  },
  {
    title: "Upcoming Bookings",
    dataIndex: "upcomingBookings",
    key: "upcomingBookings",
    sorter: (a, b) => a.upcomingBookings - b.upcomingBookings
  },
  {
    title: "Availability",
    dataIndex: "availability",
    key: "availability",
    sorter: (a, b) => a.availability.localeCompare(b.availability)
  },
  {
    title: "Next Time Off",
    dataIndex: "nextTimeOff",
    key: "nextTimeOff",
    sorter: (a, b) => a.nextTimeOff.localeCompare(b.nextTimeOff),
    render: (nextTimeOff) => <Tag color={nextTimeOff === "Active" ? "green" : "default"}>{nextTimeOff}</Tag>
  },
  {
    title: "Actions",
    key: "actions",
    render: () => (
      <Dropdown
        trigger={["click"]}
        menu={{
          className: styles.actionMenu,
          items: [
            {
              key: "edit",
              icon: <EditOutlined />,
              label: "Edit"
            },
            {
              key: "duplicate",
              icon: <CopyOutlined />,
              label: "Duplicate"
            },
            {
              key: "deactivate",
              icon: <StopOutlined />,
              label: "Deactivate"
            },
            {
              key: "delete",
              icon: <DeleteOutlined className={styles.deleteIcon} />,
              label: "Delete"
            }
          ]
        }}
        placement="bottomRight"
        arrow
      >
        <span className={styles.actionTrigger}>⋯</span>
      </Dropdown>
    )
  }
]

export default crewMembersColumns
